// extracted by mini-css-extract-plugin
module.exports = {"inputbox":"Category_inputbox__1PYOf"};